import { useEffect, useState } from "react";
import { api } from "../api/client";
import type { Exercise } from "../api/types";
import { cacheGet, cacheSet } from "../state/offline";

const KEY = "exercise-library-v1";

export const useExerciseLibrary = () => {
  const [data, setData] = useState<Exercise[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const cached = await cacheGet<Exercise[]>(KEY);
      if (cached && !cancelled) {
        setData(cached);
        setLoading(false);
      }
      try {
        const fresh = await api<Exercise[]>("/exercises");
        if (cancelled) return;
        setData(fresh);
        setLoading(false);
        void cacheSet(KEY, fresh);
      } catch (e) {
        if (cancelled) return;
        if (!cached) {
          setError(e instanceof Error ? e.message : "failed to load exercises");
          setLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { data, loading, error };
};

export const useExerciseMap = () => {
  const { data, loading } = useExerciseLibrary();
  const map = new Map(data.map((e) => [e.id, e]));
  return { map, loading };
};
